import { msg } from 'gt-react';
import { showToastOutsideReact } from 'src/services/toastService';

const DEDUP_WINDOW_MS = 3_000;
const recentMessages = new Map<string, number>();

let _isAdmin = false;

export function setNotify403IsAdmin(isAdmin: boolean): void {
  _isAdmin = isAdmin;
}

export function notify403(message: string): void {
  const now = Date.now();
  const dedupKey = _isAdmin ? message : '__generic_403__';
  const lastShown = recentMessages.get(dedupKey);

  if (lastShown !== undefined && now - lastShown < DEDUP_WINDOW_MS) {
    return;
  }

  showToastOutsideReact({
    title: msg('Access Denied'),
    message: _isAdmin
      ? message
      : msg('You do not have permission to perform this action.'),
    color: 'error',
  });

  recentMessages.set(dedupKey, now);

  if (recentMessages.size > 50) {
    for (const [key, timestamp] of recentMessages) {
      if (now - timestamp >= DEDUP_WINDOW_MS) {
        recentMessages.delete(key);
      }
    }
  }
}
